import { Alert, Icons } from '@silverfort/sf-components';
import React, {useCallback, useState} from 'react';
import ItdrContext from './ItdrContext';
import IncidentsOverviewPage from './IncidentsOverviewPage';
import { LAST_CHANGES_FILTERS } from './IncidentsOverview/Filters';
import useGetHiddenIncidentTypes from './api/queries/useGetHiddenIncidentTypes';
import { INCIDENT_STATUS } from '@silverfort-nodelibs/common/utils/consts';
import PageWrapper from '../../components/PageWrapper/PageWrapper';
import IncidentsConfigurationPage from './IncidentsConfiguration/components/incidentsConfigurationPage';

const ItdrPage = () => {
    const [isDrawerOpen, setIsDrawerOpen] = useState(false);
    const [showConfiguration, setShowConfiguration] = useState(false);
    const [lastActivityDiffInDays, setLastActivityDiffInDays] = useState<number>(LAST_CHANGES_FILTERS.LAST_7_DAYS);
    const [selectedSeverities, setSelectedSeverities] = useState<number[]>();
    const [selectedStatuses, setSelectedStatuses] = useState<number[] | undefined>([
        INCIDENT_STATUS.OPEN.value,
        INCIDENT_STATUS.IN_PROGRESS.value
    ]);
    const { data: hiddenTypes } = useGetHiddenIncidentTypes();

    const [graphRefreshToken, setGraphRefreshToken] = useState(0);

    const refreshGraph = () => {
        setGraphRefreshToken(Date.now());
    };

    const returnToMainPage = useCallback(() => {
        setShowConfiguration(false);
    }, [setShowConfiguration]);

    return (
        <PageWrapper
            icon={Icons.Target}
            title={!showConfiguration ? 'Identity Threat Detection & Response (ITDR)' : 'Incident Customization'}>
            <Alert />
            <ItdrContext.Provider
                value={{
                    exclusionDrawerOpen: isDrawerOpen,
                    setExclusionDrawerOpen: setIsDrawerOpen,
                    showConfiguration,
                    setShowConfiguration,
                    lastActivityDiffInDays,
                    setLastActivityDiffInDays,
                    setSelectedSeverities,
                    selectedSeverities,
                    selectedStatuses,
                    setSelectedStatuses,
                    hiddenTypes,
                    graphRefreshToken,
                    refreshGraph
                }}>
                {showConfiguration ? (
                    <IncidentsConfigurationPage onBackClick={returnToMainPage} />
                ) : (
                    <IncidentsOverviewPage />
                )}
            </ItdrContext.Provider>
        </PageWrapper>
    );
};

export default ItdrPage;
